import { datadogRum } from '@datadog/browser-rum';

export const datadogRumSetUser = async (user: {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}) => {
  if (user) {
    datadogRum.setUser({
      id: user.id.toString(),
      email: user.email,
      name: `${user.firstName} ${user.lastName}`.trim(),
    });
  }
};
